// Error codes return with the ON_CHANGE and ON_BLUR events of the TextFieldV2 component
// if the 3 parameter is trre, the value has an error with is one of the following, as the 4th parameter:
export const TEXTFIELD_ERROR_MAX_DIGITS_MANTISSA = 'MAX_DIGITS_MANTISSA';
export const TEXTFIELD_ERROR_MAX_DIGITS_EXPONENT = 'MAX_DIGITS_EXPONENT';
export const TEXTFIELD_ERROR_ILL_FORMED_NUMBER = 'ILL_FORMED_NUMBERr';
export const TEXTFIELD_ERROR_NUMERIC_MAX_VALUE = 'MAX_VALUEm';
export const TEXTFIELD_ERROR_NUMERIC_MIN_VALUE = 'MIN_VALUE';
export const TEXTFIELD_ERROR_TEXT_MAX_LENGTH = 'MAX_LENGTH';
export const TEXTFIELD_ERROR_TEXT_INVALID_CHARACTERS = 'INVALID_CHARACTERS';
